import { listenStoreNotifier, disconnectStore } from './listenStoreNotifier';
import { durableGetItem, durableHas, durableSetItem } from './durableStorage';
import { ref, watch } from 'vue';

// TODO: do I need more details than a boolean?
export type listeningStoresType = {
    storeId: string;
    isEnabled: boolean;
}

// record of storeId to isEnabled
export const MySettingsStore = ref<Record<string, listeningStoresType>>({});

export const addListeningStore = (storeId: string) => {
    if (!MySettingsStore.value[storeId]) {
        MySettingsStore.value[storeId] = {
            storeId,
            isEnabled: true
        };
    } else {
        MySettingsStore.value[storeId].storeId = storeId;
        MySettingsStore.value[storeId].isEnabled = true;
    }
    listenStoreNotifier(storeId);
}

export const removeListeningStore = (storeId: string) => {
    MySettingsStore.value[storeId].isEnabled = false;
    disconnectStore(storeId);
}

const getLocalStorageKey = () => {
    return `MY_SETTINGS_LISTENING_STORES_DEVICE`;
}

function initListeningStores() {
    console.log('initListeningStores');
    if (durableHas(getLocalStorageKey())) {
        MySettingsStore.value = JSON.parse(durableGetItem(getLocalStorageKey()) || '{}');
    }
    // for (const storeId in MySettingsStore.value) {
    //     if (MySettingsStore.value[storeId].isEnabled) {
    //         listenStoreNotifier(storeId);
    //     }
    // }

    watch(MySettingsStore, (newVal) => {
        durableSetItem(getLocalStorageKey(), JSON.stringify(newVal));
    }, { deep: true });
}

initListeningStores();
